import { computed, makeObservable, observable } from 'mobx'

import { EMPTY_STRING_ID } from '@/constant/common'
import stringUtils from '@/utils/String/stringUtils'

import { DTO } from '../DTO'

type AuthType = '관리자' | '전체 학생' | '담당 학생'

export class Teacher extends DTO implements res.Teacher {
  academyId = ''
  academyName = ''
  teacherId = EMPTY_STRING_ID
  loginId = ''
  name = ''
  // 문자 보내는 번호와 무관
  phone = ''
  type: res.Teacher['type'] = 'MANAGER_TEACHER'
  present
  allowedServiceTypes: res.Teacher['allowedServiceTypes'] = []

  constructor(data?: res.Teacher) {
    super()

    if (data) {
      this.academyId = data.academyId
      this.academyName = data.academyName
      this.teacherId = data.teacherId
      this.loginId = data.loginId
      this.name = data.name
      this.phone = data.phone
      this.type = data.type
      this.present = data.present
      this.allowedServiceTypes = data.allowedServiceTypes
    }
    makeObservable(this, {
      academyName: observable,
      teacherId: observable,
      loginId: observable,
      name: observable,
      phone: observable,
      type: observable,
      present: observable,
      allowedServiceTypes: observable,
      id: computed,
      isAdmin: computed,
      authType: computed,
      dashedPhone: computed,
      isEnglishflatAllowed: computed,
    })
  }

  get id() {
    return this.teacherId
  }

  get isEnglishflatAllowed() {
    return this.allowedServiceTypes.includes('ENGLISHFLAT')
  }

  get isScienceflatAllowed() {
    return this.allowedServiceTypes.includes('SCIENCEFLAT')
  }

  get isAdmin(): boolean {
    return this.authType === '관리자'
  }

  get authType(): AuthType {
    switch (this.type) {
      case 'ROOT_TEACHER':
        return '관리자'
      case 'HOMEROOM_TEACHER':
        return '담당 학생'
      case 'MANAGER_TEACHER':
      default:
        return '전체 학생'
    }
  }

  get dashedPhone() {
    const number = this.phone.match(/\d+/g)?.join('')
    return number ? stringUtils.toDashedPhone(number) : this.phone
  }
}
